// import React, { useEffect, useState } from "react";
// import { io } from "socket.io-client";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const AdminSocketListener = () => {
//   const [notifCount, setNotifCount] = useState(0);
//   const originalTitle = document.title;

//   useEffect(() => {
//     const socket = io("http://localhost:8096", {
//       transports: ["websocket"],
//     });

//     socket.on("connect", () => {
//       console.log("✅ Connected to Socket.IO:", socket.id);
//     });

//     // Listen for new orders
//     socket.on("newOrder", (data) => {
//       // console.log("🆕 New Order:", data);

//       // Increment notification count
//       setNotifCount((prev) => prev + 1);

//       // Show toast notification
//       toast.info(`${data.title}: ${data.body}`, {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         theme: "colored",
//       });

//       // Also show browser notification
//       if (Notification.permission === "granted") {
//         new Notification(data.title, { body: data.body });
//       } else if (Notification.permission !== "denied") {
//         Notification.requestPermission().then((permission) => {
//           if (permission === "granted") {
//             new Notification(data.title, { body: data.body });
//           }
//         });
//       }
//     });

//     return () => {
//       socket.disconnect();
//     };
//   }, []);

//   // 🧠 Update the document title dynamically
//   useEffect(() => {
//     if (notifCount > 0) {
//       document.title = `(${notifCount}) Nofication • ${originalTitle}`;
//     } else {
//       document.title = originalTitle;
//     }
//   }, [notifCount]);

//   // 🧹 Reset title and count when admin clicks tab (optional)
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (document.visibilityState === "visible") {
//         setNotifCount(0);
//       }
//     };
//     document.addEventListener("visibilitychange", handleVisibilityChange);
//     return () =>
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//   }, []);

//   return <ToastContainer />;
// };

// export default AdminSocketListener;
import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdminSocketListener = ({ onNewNotification }) => {
  const [notifCount, setNotifCount] = useState(0);
  const [notifTypes, setNotifTypes] = useState({});
  const originalTitle = document.title;

  useEffect(() => {
    const socket = io("http://localhost:8096", { transports: ["websocket"] });

    socket.on("connect", () => console.log("✅ Connected to Socket.IO:", socket.id));

    socket.on("newOrder", (data) => {
      // Increment total count
      setNotifCount((prev) => prev + 1);

      // Track notification type dynamically
      setNotifTypes((prev) => ({ ...prev, [data.title]: true }));

      // Callback to parent (for sidebar red dots)
      if (onNewNotification) onNewNotification(data.title);

      // Toast
      toast.info(`${data.title}: ${data.body}`, { position: "top-right", autoClose: 5000, theme: "colored" });

      // Browser notification
      if (Notification.permission === "granted") {
        new Notification(data.title, { body: data.body });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") new Notification(data.title, { body: data.body });
        });
      }
    });

    return () => socket.disconnect();
  }, [onNewNotification]);

  useEffect(() => {
    document.title = notifCount > 0 ? `(${notifCount}) Notification • ${originalTitle}` : originalTitle;
  }, [notifCount, originalTitle]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") setNotifCount(0);
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  return <ToastContainer />;
};

export default AdminSocketListener;
